module.exports = __webpack_public_path__ + "static/media/sharepoint-online-integrations.60a30521.svg";